var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRcSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-rc-success",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M512 992.59733333c-265.44507221 0-480.59733333-215.15226112-480.59733333-480.59733333S246.55492779 31.40266667 512 31.40266667s480.59733333 215.15226112 480.59733333 480.59733333-215.15226112 480.59733333-480.59733333 480.59733333z m0-87.38133333a393.216 393.216 0 1 0 0-786.432 393.216 393.216 0 0 0 0 786.432z m214.08426667-575.45462557a43.69066667 43.69066667 0 1 1 61.74947555 61.74947556l-308.94155889 308.9415589a43.69066667 43.69066667 0 0 1-61.74947556 0L262.67192889 545.98163001a43.69066667 43.69066667 0 1 1 61.74947556-61.74947556l123.5960411 123.54749554 278.06682112-278.01827556z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcSuccess);
export default __webpack_public_path__ + "static/media/rc-success.0f47ea446dfba73c3d9ce9f738116af7.svg";
export { ForwardRef as ReactComponent };